module.exports = __webpack_public_path__ + "static/media/checkcircle.47c81a36.svg";